import FileSelect from '../../../elements/FileSelect'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withData from '../../../elements/Select/withData'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
  TwoPartThreeColFormItemLayout,
  boolLabelItemLayout,
} from '../../../modules/FormItems'
import React from 'react'
import { Checkbox, Col, Form, Input, Row, Select } from 'antd'
import { get } from 'lodash'

import { compose } from 'recompose'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import AccountsCascader from '../../../elements/Cascader/AccountsCascader'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withKeyValue from '../../../elements/HOC/WithKeyValue'

const { TextArea } = Input

const TypeSelect = compose(
  withSelectFetch({ dropdown: 'products', name: 'type' }),
  withKeyValue(),
  withSort,
)(CustomSelect)

const TagSelect = compose(
  withSelectFetch({ dropdown: 'products', name: 'industryTags' }),
  withKeyValue(),
  withSort,
)(CustomSelect)

const StateSelect = compose(
  withData({
    data: [
      { key: 'Closed', value: 'Closed' },
      { key: 'Active', value: 'Active' },
    ],
  }),
  withSort,
)(CustomSelect)

function ProductForm (props) {
  const { product, modalType } = props
  const { getFieldDecorator, setFieldsValue, resetFields, getFieldValue } = props.form
  const type = getFieldValue('type') || get(product, 'type')
  const industryTags = getFieldValue('industryTags') || get(product, 'industryTags')
  const company = getFieldValue('company._id') || get(product, 'company._id')
  const category = getFieldValue('category._id') || get(product, 'category._id')
  const group = getFieldValue('group._id') || get(product, 'group._id')

  const [CategorySelect] = useFetchSelectUrl(
    {
      name: 'products_categories',
      forceFetch: true,
      url: `products/categories/dropdown?select=*&type=${type}`,
    },
    [type],
    false,
    Select,
    (c) => c,
    () => resetFields(['group._id', 'category._id']),
  )
  const [GroupsSelect] = useFetchSelectUrl(
    {
      name: 'products_groups',
      forceFetch: true,
      url: `products/groups/dropdown?category=${category}&select=*`,
    },
    [company, category],
    false,
    Select,
    (c) => c,
    () => resetFields(['group._id']),
  )

  /*const { data, fetching, fetchURL } = useFetchURL(`/foxxapi/dropdowns/products/SKUTypes`)
  const SKUSelect = compose(
    withSpinning,
    withData({
      data: data,
      fetch: fetchURL,
      fetching: fetching,
    }),
    withSort,
  )(CustomCascader)*/

  return (
    <Form>
      {/* Product Details */}
      <>
        <Row>
          <Col span={12}>
            <Form.Item {...TwoPartThreeColFormItemLayout} label="Name">
              {getFieldDecorator('name', {
                initialValue: get(product, 'name'),
                rules: rules.input,
              })(<Input placeholder={'Name'}/>)}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...boolLabelItemLayout} label={'IS A SERVICE'}>
              {getFieldDecorator('isService', {
                initialValue: get(product, 'isService'),
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
          {getFieldValue('isService') === true && (
          <Col span={6}>
            <Form.Item {...boolLabelItemLayout} label={'IS FREIGHT'}>
              {getFieldDecorator('isFreight', {
                initialValue: get(product, 'isFreight'),
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
          )}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Activity">
              {getFieldDecorator('type', {
                initialValue: get(product, 'type'),
                rules: rules.select,
              })(<TypeSelect mode="multiple" style={{ width: '100%' }} placeholder="Please select"/>)}
            </Form.Item>
          </Col>
          {modalType === 'edit' && (
            <FileSelect
              {...{
                doc: product,
                getFieldValue,
                getFieldDecorator,
                acc: 'image',
                label: 'Cover Image',
              }}
            />
          )}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Category">
              {getFieldDecorator('category._id', {
                initialValue: get(product, 'category._id'),
                rules: rules.select,
              })(<CategorySelect placeholder={'Category'} keyAtr={'_id'} valueAtr={'name'}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            {/*{category && (*/}
            <Form.Item {...defaultFormItemLayout} label="Group">
              {getFieldDecorator('group._id', {
                initialValue: get(product, 'group._id'),
                rules: rules.select,
              })(<GroupsSelect placeholder={'Group'} keyAtr={'_id'} valueAtr={'name'}/>)}
            </Form.Item>
            {/*)}*/}
          </Col>
        </Row>
        {getFieldValue('isService') !== true && (
          <Row>
            {/*<Col span={16}>
              <Form.Item {...TwoPartThreeColFormItemLayout} label="Type">
                {getFieldDecorator('SKUTypes', {
                  initialValue: get(product, 'SKUTypes'),
                  //rules: rules.select,
                })(<SKUSelect keyAtr={'name'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>*/}
            <Col span={12}>
              <Form.Item {...TwoPartThreeColFormItemLayout} label="Industries">
                {getFieldDecorator('industryTags', {
                  initialValue: get(product, 'industryTags'),
                  //rules: rules.select,
                })(<TagSelect mode="multiple" style={{ width: '100%' }} placeholder="Please select"/>)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'IS FOR SALE'}>
                {getFieldDecorator('isForSale', {
                  initialValue: get(product, 'isForSale'),
                  valuePropName: 'checked',
                })(<Checkbox/>)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'IS STOCKED'}>
                {getFieldDecorator('isStocked', {
                  initialValue: get(product, 'isStocked'),
                  valuePropName: 'checked',
                })(<Checkbox/>)}
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row></Row>
        {getFieldValue('isService') !== true ? (
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Design & Features">
                {getFieldDecorator('description', {
                  initialValue: get(product, 'description'),
                })(<TextArea rows={8}/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Row>
                <Col span={24}>
                  <Form.Item {...defaultFormItemLayout} label="Material">
                    {getFieldDecorator('specifications.material', {
                      initialValue: get(product, 'specifications.material'),
                      //rules: rules.input,
                    })(<Input placeholder={'Material'}/>)}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...defaultFormItemLayout} label="Shelf Life">
                    {getFieldDecorator('specifications.shelfLife', {
                      initialValue: get(product, 'specifications.shelfLife'),
                      //rules: rules.input,
                    })(<Input placeholder={'Shelf Life'}/>)}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...defaultFormItemLayout} label="Storage">
                    {getFieldDecorator('specifications.storage', {
                      initialValue: get(product, 'specifications.storage'),
                      //rules: rules.input,
                    })(<Input placeholder={'Storage'}/>)}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Service Description">
                {getFieldDecorator('description', {
                  initialValue: get(product, 'description'),
                })(<TextArea rows={8}/>)}
              </Form.Item>
            </Col>
          </Row>
        )}
      </>
      <Row>
        <h3>ACCOUNTING DETAILS</h3>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Company'}>
            {getFieldDecorator('company._id', {
              initialValue: get(product, 'company._id'),
              rules: rules.select,
            })(<OrganisationsSelect onChange={() => setFieldsValue({ 'accounts.revenue': [], 'accounts.cos': [] })}/>)}
          </Form.Item>
        </Col>
        {modalType === 'edit' && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'State'}>
              {getFieldDecorator('state', {
                initialValue: get(product, 'state'),
                rules: rules.select,
              })(<StateSelect placeholder={'State'}/>)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <>
        {company && (
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Revenue Account'}>
                {getFieldDecorator('accounts.revenue', {
                  initialValue: get(product, 'accounts.revenue'),
                  rules: rules.select,
                })(
                  <AccountsCascader
                    parentName={'REVENUE'}
                    company={getFieldValue('company._id')}
                    placeholder={'Revenue Account'}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'COS Account'}>
                {getFieldDecorator('accounts.cos', {
                  initialValue: get(product, 'accounts.cos'),
                  rules: rules.select,
                })(
                  <AccountsCascader
                    parentName={'COS'}
                    company={getFieldValue('company._id')}
                    placeholder={'COS Account'}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
        )}
      </>
    </Form>
  )
}

ProductForm.propTypes = {}
ProductForm.defaultProps = {}

export default Form.create()((ProductForm))
